import React, { useEffect, useState } from 'react';
import { Card, CardBody } from '@nextui-org/react';
import { URLs } from '../../constants/apiEndpoints';
import { PrivateAxiosInstance } from '../../services/createAxiosInstance';
import moment from 'moment';
import { message } from 'antd';
import Loading from '../Loading/Loading';
import { useNavigate } from 'react-router-dom';

function NoticePanel() {
  const [loading, setLoading] = useState(false);
  const [articles, setArticles] = useState([]);

  const navigate = useNavigate();

  const getArticle = async () => {
    setLoading(true);
    try {
      const queryParams = new URLSearchParams({
        page: '1',
        limit: '4',
        status: false,
      }).toString();

      const res = await PrivateAxiosInstance.get(
        `${URLs.GET_ALL_ARTICLES}?${queryParams}`
      );
      const data = res?.data?.articles;
      setArticles(data);
    } catch (error) {
      message.error('Failed to fetch articles');
      console.error('Error fetching articles:', error);
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    getArticle();
  }, []);

  const navigateToArticle = (id) => {
    if (!id) {
      message.error('Articles ID not found');
    }
    navigate(`market-analysis/article/${id}`);
  };

  return (
    <div className="bg-background-secondary-color font-poppins h-full rounded-xl mb-10 ml-10 xm:mr-[-50px] sm:mr-[-30px] lg:mr-2 hidden md:block">
      {loading ? (
        <Loading isLoading={loading} />
      ) : (
        articles?.map((article, index) => (
          <Card
            onPress={() => navigateToArticle(article?.articleId)}
            isPressable
            key={index}
            className="bg-background-secondary-color mt-5 w-full"
          >
            <CardBody>
              <h4 className="text-lg font-semibold text-poppins text-gray-200">
                {article?.articleName}
              </h4>
              <h4 className="text-md font-normal text-poppins text-gray-300 line-clamp-2">
                {article?.description
                  ? article?.description.replace(/<[^>]+>/g, '')
                  : ''}
              </h4>
              <p className="text-sm font-normal text-poppins text-gray-400">
                {moment(article?.createdAt).fromNow()}
              </p>
            </CardBody>
          </Card>
        ))
      )}
    </div>
  );
}

export default NoticePanel;
